module.exports = __webpack_public_path__ + "6cb99f940bb3b4968a931848f573b907.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/balloon.png
// module id = 1979
// module chunks = 0